/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Insert_Speaker_Uppercase_LabelInputs */



/**
* | output |
* | --- |
* | "Uppercase All" |
*
* @param {Insert_Speaker_Uppercase_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const insert_speaker_uppercase_label = /** @type {((inputs?: Insert_Speaker_Uppercase_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insert_Speaker_Uppercase_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tout en majuscules")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle Großbuchstaben")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tutto maiuscolo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Все заглавными буквами")
	if (locale === "es") return /** @type {LocalizedString} */ ("Todo en mayúsculas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("全部大写")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべて大文字")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी अक्षर बड़े अक्षरों में")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tudo em maiúsculas")
	return /** @type {LocalizedString} */ ("Uppercase All")
});